export default __webpack_public_path__ + "static/media/flower.ba2f352a.png";